import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { SectionInner } from '../components/SectionInner';
import { CornerFrame } from '../components/CornerFrame';

export function AboutForum() {
  const { aboutForum } = conventionContent;
  return (
    <Box
      component="section"
      id={aboutForum.sectionId}
      aria-labelledby={aboutForum.headingId}
      sx={{
        backgroundColor: 'background.default',
        paddingBlock: { mobile: pxToRem(48), laptop: pxToRem(120) },
      }}
    >
      <SectionInner
        direction={{ mobile: 'column', laptop: 'row' }}
        gap={{ mobile: pxToRem(48), laptop: pxToRem(64) }}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: { mobile: pxToRem(299), laptop: pxToRem(288) },
            height: { mobile: pxToRem(310), laptop: pxToRem(407) },
            flexShrink: 0,
          }}
        >
          <CornerFrame
            corner="bottom-left"
            inset={{
              mobile: { horizontal: 19, vertical: 20 },
              laptop: { horizontal: 19, vertical: 21 },
            }}
            radius={{ mobile: 27, laptop: 27 }}
          />
          <Stack
            gap={pxToRem(24)}
            sx={{
              position: 'absolute',
              top: { mobile: pxToRem(21), laptop: pxToRem(21) },
              left: { mobile: '50%', laptop: pxToRem(50) },
              transform: { mobile: 'translateX(-50%)', laptop: 'none' },
              width: { mobile: pxToRem(211), laptop: pxToRem(200) },
              alignItems: { mobile: 'center', laptop: 'flex-start' },
              textAlign: { mobile: 'center', laptop: 'left' },
              color: 'primary.main',
            }}
          >
            <Typography
              component="h2"
              id={aboutForum.headingId}
              variant="h2"
              sx={{
                fontSize: { mobile: pxToRem(24), laptop: pxToRem(32) },
                lineHeight: { mobile: pxToRem(32), laptop: pxToRem(40) },
                margin: 0,
                width: '100%',
              }}
            >
              {aboutForum.heading}
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Roboto", sans-serif',
                fontWeight: 700,
                fontSize: { mobile: pxToRem(16), laptop: pxToRem(18) },
                lineHeight: pxToRem(20),
                margin: 0,
              }}
            >
              {aboutForum.summary}
            </Typography>
          </Stack>
        </Box>

        <Stack
          gap={{ mobile: pxToRem(20), laptop: pxToRem(24) }}
          sx={{
            width: { mobile: pxToRem(288), laptop: pxToRem(575) },
            color: 'primary.main',
            textAlign: { mobile: 'center', laptop: 'left' },
          }}
        >
          {aboutForum.paragraphGroups.map((group, groupIndex) => (
            <Stack key={groupIndex} gap={{ mobile: pxToRem(20), laptop: 0 }}>
              {group.map((paragraph, index) => (
                <Typography
                  key={index}
                  sx={{
                    fontFamily: '"Roboto", sans-serif',
                    fontWeight: 400,
                    fontSize: { mobile: pxToRem(16), laptop: pxToRem(18) },
                    lineHeight: { mobile: pxToRem(20), laptop: pxToRem(24) },
                    margin: 0,
                  }}
                >
                  {paragraph}
                </Typography>
              ))}
            </Stack>
          ))}
        </Stack>
      </SectionInner>
    </Box>
  );
}
